export enum SalesAppointmentType {
  Sales = 'SALES',
  TestRide = 'TEST_RIDE',
  Options = 'OPTIONS',
}

export enum SalesAppointmentStatus {
  Pending = 'PENDING',
  Accepted = 'ACCEPTED',
  Rejected = 'REJECTED',
}

export interface SalesAppointmentResponse {
  id: string
  dealerId: string
  leadId: string
  startDate: string
  endDate: string
  appointmentType: SalesAppointmentType
  status: SalesAppointmentStatus
  origin?: string
  createdAt?: string
  model?: string
  comment?: string
  contact?: {
    name: string
    phone: string
    email?: string
  }
  assignee?: {
    email: string
    name: string
  }
}
